import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import admin from "./plugins/admin";
import "./plugins/i18n";
import "./plugins/base";
import "./plugins/chartist";
import "./sass/overrides.sass";

// install keycloak (removed)

// https://randomcodetips.com/vue-html-to-paper/
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
};
Vue.use(VueHtmlToPaper, options)

import XLSX from 'xlsx'
Vue.prototype.XLSX = XLSX

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// import VueFriendlyIframe from 'vue-friendly-iframe';
// Vue.use(VueFriendlyIframe);

import { msalInstance } from "@/plugins/msal";

Vue.config.productionTip = false;

// Ensure MSAL processes any pending interaction results (e.g. from redirects or popups)
async function handleMsalRedirect() {
  try {
    const result = await msalInstance.handleRedirectPromise();
    
    if (result) {
      localStorage.setItem("auth_type", "msal");
      console.log("MSAL login successful");
      
      // If we are in the top-level window and it might have been a redirect login
      if (window.location.pathname.includes("/authen")) {
        window.location.href = "/overview";
        return true; // Stop further execution as we are redirecting
      }
    }
    return false;
  } catch (err) {
    console.error("MSAL redirect error", err);
    return false;
  }
}

handleMsalRedirect().then((redirected) => {
  if (redirected) return;

  const authType = localStorage.getItem("auth_type");
  
  // Check if we are in an MSAL popup or iframe callback
  // MSAL handles closing the popup automatically when handleRedirectPromise is called in the popup window.
  // We MUST NOT mount the Vue app in the popup/iframe as it can interfere with this process.
  const isPopup = window.opener && window.opener !== window;
  const isIframe = window !== window.top;

  if (isPopup || isIframe) {
    console.log("Detected MSAL interaction window (iframe/popup) - skipping mount to allow MSAL to close the window");
    return;
  }

    new Vue({
      router,
      store,
      i18n,
      vuetify,
      admin,
      render: (h) => h(App),
    }).$mount("#app");
}).catch(err => {
  console.error("MSAL handleRedirectPromise error", err);
  const authType = localStorage.getItem("auth_type");
  
  // Clean up if we are in a popup/iframe even on error
  const isPopup = window.opener && window.opener !== window;
  const isIframe = window !== window.top;
  if (isPopup || isIframe) {
    return;
  }

  new Vue({
    router,
    store,
    i18n,
    vuetify,
    admin,
    render: (h) => h(App),
  }).$mount("#app");
});

// new Vue({
//   router,
//   store,
//   i18n,
//   vuetify,
//   admin,
//   render: (h) => h(App),
// }).$mount("#app");
